module.exports = __webpack_public_path__ + "static/media/honda-muti-parking-selected.cf0e8fae.svg";